<template>
  <div class="container">
    <!-- 侧边栏 -->
    <div class="sidebar">
      <my-component></my-component>
    </div>
	
    
    <!-- 右侧内容 -->
    <div class="content" >
      <!-- 你的 blockAll 元素 -->
      <div class="blockAll">
        <div
          class="everyBlock"
          v-for="(item, index) in blockData"
          :key="index"
          :style="{ background: item.color }"
          @click="goToNewPage(item)"
        >
		
		
		           <div class="blockId" style="display: flex; align-items: center; justify-content: center;">{{ item.id }}{{ item.num }}</div>
		         
		       
           
        </div>
      </div>
      
      <!-- 你的 charts 元素 -->
      <div class="charts">
        <div id="chartLineBox" style="width: 100%; height: 300px ;background-color: rgb(26,35,45); " > </div>
      </div>
      
      <!-- 你的 block 元素 -->
      <div class="block" >
        <div class="page-header" >
         最近区块</div>
        <div
        <div
          class="mobile_cell"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <van-cell-group :border="false">
            <van-cell title="区块高度" :value="item.height" :border="false">
              <template>
                <router-link
                  style="text-decoration: none"
                  :to="{
                    path: '/blockDetail',
                    query: { height: item.height },
                  }"
                >{{ item.height }}
                </router-link>
              </template>
            </van-cell>
            <van-cell title="区块哈希" :value="item.block_hash" :border="false">
              <template>
                <router-link
                  style="text-decoration: none"
                  :to="{
                    path: '/blockDetail',
                    query: { height: item.height },
                  }"
                >{{ item.block_hash }}
                </router-link>
              </template>
            </van-cell>
            <van-cell title="生成日期" :border="false">{{ item.time | timeformat() }}</van-cell>
          </van-cell-group>
        </div>
        <van-button style="background-color:rgb(37,49,63); border:none;color:white; "block @click="goAllBlock" >查看更多</van-button>
      </div>
      
      <!-- 你的 tx 元素 -->
      <div class="tx">
        <div>
          <div class="page-header" >
           最近存证</div>
        </div>
        <div
          class="mobile_cell"
          v-for="(item, index) in tableData1"
          :key="index"
        >
          <van-cell-group :border="false">
            <van-cell title="存证哈希" :value="item.tx_hash" :border="false">
              <template>
                <router-link
                  style="text-decoration: none"
                  :to="{
                    path: '/txDetail',
                    query: { tx_hash: item.tx_hash },
                  }"
                >{{ item.tx_hash }}
                </router-link>
              </template>
            </van-cell>
            <van-cell title="区块高度" :value="item.height" :border="false">
              <template>
                <router-link
                  style="text-decoration: none"
                  :to="{
                    path: '/blockDetail',
                    query: { height: item.height },
                  }"
                >{{ item.height }}
                </router-link>
              </template>
            </van-cell>
            <van-cell title="存证时间" :value="item.time" :border="false" />
          </van-cell-group>
        </div>
        <van-button  style="background-color:rgb(37,49,63); border:none;color:white; " block @click="goAllTx">查看更多</van-button>
      </div>
    </div>
  </div>
</template>
<script>
	// 假设 MyComponent.vue 和 MyView.vue 在同一个目录下
	import MyComponent from '@/components/MyComponent.vue';
export default {
	components: {
	    MyComponent // 这样注册后，在模板中可以直接使用 <my-component> 标签
	  },
  data() {
    return {
      timeDate: [
        this.getDayBefore(-7),
        this.getDayBefore(-6),
        this.getDayBefore(-5),
        this.getDayBefore(-4),
        this.getDayBefore(-3),
        this.getDayBefore(-2),
        this.getDayBefore(-1),
        this.getDayBefore(0),
        this.getDayBefore(1),
        this.getDayBefore(2),
        this.getDayBefore(3),
        this.getDayBefore(4),
        this.getDayBefore(5),
        this.getDayBefore(6),
      ],
      numData: [11, 2, 22, 50, 22, 22, 22, 11, 2, 22, 50, 22, 22, 22],
      blockData: [
        { id: "当前快高", num: 100, color: "#3d55a5", path: "/index" },
        { id: "存证数量", num: 0, color: "#92cce1" },
        { id: "节点数量", num: 42, color: "#fed9a1" },
        { id: "出块时间", num: 100, color: "#fe8778" },
      ],
      tableData1: [],
      tableData: [],
    };
  },
  filters: {
    timeformat(val) {
      if (val && typeof val == "string") {
        return val.substring(0, val.indexOf("."));
      }
    },
  },
  mounted() {
    this.showCharts();
    this.getBlockTable();
    this.getTxTable();
    this.timer = window.setInterval(() => {
      setTimeout(() => {
        this.getBlockTable();
        this.getTxTable();
      }, 0);
    }, 3000);
  },
  methods: {
    goToNewPage(item) {
      if (item.id == "当前快高") {
        this.$router.push({
          path: "/blockDetail",
          query: { height: item.num },
        });
      }
    },
    getDayBefore(day) {
      var date = new Date();
      var timeBefore = date.getTime() + 1000 * 60 * 60 * 24 * day;
      date = new Date(timeBefore);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      //获取当前月份的最后一天
      var d = new Date(year, month, 0);
      var lastDay = d.getDate();
      if (day > lastDay) {
        day = "01";
        if (month == 12) {
          month = "01";
          year += 1;
        } else {
          month += 1;
        }
      } else {
      }
      month = month.toString().padStart(2, "0");
      day = day.toString().padStart(2, "0");
      // return `${year}-${month}-${day}`;
      return `${month}-${day}`;
    },
    getBlockTable() {
      this.$http.get(`${block_ip}blocks/1/5`).then((res) => {
        let data = res.data.data;
        if (data) {
          this.blockData[1].num = data[0].totalTxs;
          this.blockData[0].num = data[0].height;
          this.blockData[3].num =
            (new Date(data[0].time).getTime() -
              new Date(data[1].time).getTime()) /
              1000 +
            "/S";
          this.tableData = data;
        }
      });
    },
    getTxTable() {
      this.$http.get(`${block_ip}txs/1/5`).then((res) => {
        let data = res.data.data;
        if (data) {
          this.tableData1 = data;
        }
      });
    },
    goDetailBlock(value) {
      this.$router.push("");
    },
    goAllBlock() {
      this.$router.push("/block");
    },
    goAllTx() {
      this.$router.push("/transaction");
    },
    showCharts() {
      this.chartLine = this.echarts.init(
        document.getElementById("chartLineBox")
      );

      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        title: {
          text: "近14日存证总量",
          subtext: "",
		  textStyle: { // 添加这个属性来自定义标题样式
		        color: "white" ,// 设置标题颜色为白色
				
		      },
		 padding: [10, 20, 20, 20], // 设置标题与图表边框的距离，顺序为 [上，右	  
        },
        grid: {
          left: "8%",
        },
        legend: {
          left: "center",
        },
        color: ["#f90", "#67c23a"],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.timeDate,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            interval: "auto",
          },
        },
        series: [
          {
            // height: "aaaa",
            type: "line",
            data: this.numData,
            type: "line",
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
    setColor() {
      this.blockData.forEach((item, index) => {
        let el = this.$refs["gridItem" + index];
      });
    },
    onClickIcon() {
      Toast("点击图标");
    },
    onClickButton() {
      Toast("点击按钮");
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
};

</script>
<style lang="scss" scoped>
	
	.blockAll {
	  display: flex; /* 使用 Flexbox */
	  flex-wrap: wrap; /* 允许换行 */
	  justify-content: space-around; /* 四周留白 */
	  align-items: stretch; /* 拉伸子元素以填满容器 */
	
	 
	}
	.blockContent{
		display: flex;
	}
	
	.everyBlock {
	  flex: 1; /* 每个块至少占据1份空间 */
	  min-width: 150px; /* 设置最小宽度，防止过窄 */
	  margin: 10px; /* 每个块之间的间距 */
	  box-sizing: border-box; /* 边框计算在宽度内 */
	    padding:10px;
		font-weight:bold;
	
	  /* 其他样式 */
	}
	.van-cell {
		background-color: rgb(26,35,45);
		color:white;
		
	}
	.container {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  flex:1;
  height: 100vh; /* 侧边栏高度 */
  
}


.content {
  flex:9;
  padding: 20px; /* 内容区域的内边距 */
  background-color: rgb(37,49,63);
}
.charts {
  margin: 0 15px;
  margin-bottom: 20px;
  background-color:rgb(26,35,45);
}
.mobile_cell {
  border: 1px solid rgb(37,49,63);
  border-width: 1px 0;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

.search-icon {
  font-size: 16px;
  line-height: inherit;
}
.vna-cell{
	 background-color:rgb(26,35,45);
}
.van-cell__value {
  flex: 3;
}
.van-cell__value {
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  
}
a {
  color: white ; /* 设置链接的颜色为黑色 */
  text-decoration: none; /* 移除下划线 */
}
.blockAll {
  margin-bottom: 20px !important;
   background-color:rgb(26,35,45);
  margin: 0 15px;
  display: flex;
  flex-wrap: wrap;
  .everyBlcok {
    width: 50%;
    margin-bottom: 10px;
  }
  p {
    text-align: right;
    margin-bottom: 0;
    font-size: 20px;
  }
}
.van-grid {
  p {
    margin: 0;
    padding: 10px 0;
    width: 100%;
  }
}
/deep/ .van-grid-item__content {
  background-color: none;
}
.block {
  margin: 0 15px;
   background-color:rgb(26,35,45);
  margin-bottom: 20px;
}
.tx {
  margin: 0 15px;
  background-color: #fff;
  margin-bottom: 20px;
}

.page-header {
  padding: 15px; /* 根据需要调整内边距 */
  background-color: rgb(37,49,63); /* 背景颜色 */
  position: relative; /* 相对定位，如果需要定位子元素 */
  font-size:18px;
  color:white;
  font-weight:bold;
  background-color: rgb(26,35,45);
   
} 
</style>